import { render } from "./indexs.vue?vue&type=template&id=67181d9a"
import script from "./indexs.vue?vue&type=script&lang=js"
export * from "./indexs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__